import {
  capitalizeAll,
  hexToRgb,
  objectEntries,
  objectFromEntries,
  satisfiesRecord,
} from "@nens/shared-utils";

import { WaterflowConfig } from "../../state/layerCalculationMenu";
import { Layers } from "../../state/layerOneDMenu";

type Color = [number, number, number];

export const STATIC_COLORS = satisfiesRecord<Color>()({
  SELECTED: [255, 0, 0],
  WHITE: [255, 255, 255],
  BLACK: [0, 0, 0],
  GREY: [59, 59, 59],
  PUMP_LINE: [101, 101, 101],
  GRID_LINES: [128, 239, 157],
  GRID_FLOW_LINES: [107, 103, 103],
  GRID_FLOW_LINES_INTERSECTING: [252, 174, 174],
  LEVEE_EDIT: [0, 0, 255],
  LEVEE_EDIT_NOT_ALLOWED: [255, 0, 0],
});

export const getCalculationLayersColors = (calculationLayersStyles: {
  waterflows: WaterflowConfig;
}) =>
  satisfiesRecord<Color>()({
    ...STATIC_COLORS,
    WATERFLOWS: hexToRgb(calculationLayersStyles.waterflows.color),
  });

export const getLayerColors = (adaptedLayerStyle: Layers) => {
  const LAYER_COLORS = objectFromEntries(
    objectEntries(adaptedLayerStyle).map(([key, { color }]) => [
      capitalizeAll(key),
      hexToRgb(color),
    ])
  );
  const PIPE_LAYER_COLORS = objectFromEntries(
    objectEntries(adaptedLayerStyle.pipes.pipeStyles).map(([key, { color }]) => [
      ("PIPES_" + key) as `PIPES_${typeof key}`,
      hexToRgb(color),
    ])
  );
  return {
    ...STATIC_COLORS,
    ...LAYER_COLORS,
    ...PIPE_LAYER_COLORS,
  };
};

const width = 900 / 3;
const height = 900 / 3;

export const ICON_MAPPING = {
  breaches: { x: 0, y: 0, width, height, mask: false },
  pumps: { x: width, y: 0, width, height, mask: false },
  manholes: { x: 0, y: height, width, height, mask: false },
  weirs: { x: width, y: height, width, height, mask: false },
  cancel: { x: 0, y: height * 2, width, height, anchorX: width + width / 3, mask: false },
  cancelNoAnchor: { x: 0, y: height * 2, width, height, mask: false },
  confirm: { x: width, y: height * 2, width, height, anchorX: -width / 3, mask: false },
  confirmNoAnchor: { x: width, y: height * 2, width, height, mask: false },
  pumpPin: { x: width * 2, y: height, width, height, anchorY: height, mask: false },
  dischargePin: { x: width * 2, y: 0, width, height, anchorY: height, mask: false },
  selectedPointPin: { x: width * 2, y: height * 2, width, height, anchorY: height, mask: false },
};

export const MAP_TILER_API_KEY = "8R286WIJ0x3O8OpGAQ6L";
